var map = {
	"./ACOS.svg": "6ff4",
	"./Add.svg": "d760",
	"./Admin Home.svg": "d346",
	"./Arrow_Down.svg": "27c1",
	"./Arrow_Left.svg": "56a5",
	"./Arrow_Right.svg": "96f0",
	"./Arrow_Up.svg": "c940",
	"./Automated systems.svg": "8ab5",
	"./Automated.svg": "2275",
	"./Availability Tracking.svg": "4963",
	"./Best Sellers Ranking.svg": "0247",
	"./Buybox Monitor.svg": "74e1",
	"./CPC.svg": "aade",
	"./CPM.svg": "cf2f",
	"./Category.svg": "d568",
	"./Centralized data.svg": "4e84",
	"./Clicks.svg": "0999",
	"./Compliance Automation.svg": "22ba",
	"./Compliance New.svg": "0a7a",
	"./Conversion Rate.svg": "05cc",
	"./Cost.svg": "6392",
	"./Customized.svg": "127f",
	"./Dashboard.svg": "7e93",
	"./Date.svg": "2233",
	"./Download.svg": "6e37",
	"./DownloadIcon.svg": "b2f0",
	"./Error free.svg": "4d9e",
	"./Filter.svg": "d54a",
	"./Form.svg": "9dd9",
	"./Important Bulletin.svg": "eccd",
	"./Impressions.svg": "cc26",
	"./Inhouse ecosystem.svg": "6813",
	"./Key Metrics.svg": "7459",
	"./LQS Analyser.svg": "d55e",
	"./Listing Analyser.svg": "1f4b",
	"./Location.svg": "a26f",
	"./Logout.svg": "b44b",
	"./Market Explorer.svg": "38d7",
	"./Market.svg": "59ed",
	"./Minus.svg": "89a5",
	"./Orders.svg": "9338",
	"./Overall spends.svg": "280a",
	"./Password.svg": "b37e",
	"./Phrase Analyser.svg": "0b7c",
	"./Plus.svg": "ca84",
	"./Price Tracking.svg": "571f",
	"./Price.svg": "ebce",
	"./Profile Dropdown.svg": "64e3",
	"./ROI.svg": "19b0",
	"./Remove.svg": "2e90",
	"./Reports.svg": "916f",
	"./Revenue.svg": "ca07",
	"./Reviews and Ratings.svg": "a575",
	"./SOV Report.svg": "489b",
	"./SQL Sync.svg": "178f",
	"./Search.svg": "a17d",
	"./Sentiments.svg": "ad03",
	"./Share of Search.svg": "c528",
	"./Share of Voice.svg": "5902",
	"./Sidebar Toggle Left.svg": "5926",
	"./Sidebar Toggle Right.svg": "0b91",
	"./Sort.svg": "b8cf",
	"./Spider Management.svg": "272a",
	"./Spider Monitor.svg": "fdc3",
	"./Submit.svg": "19a3",
	"./Summary.svg": "addf",
	"./Tooltip.svg": "82d2",
	"./User.svg": "21ec",
	"./UserProfile.svg": "5527",
	"./Visual analysis.svg": "ffc3",
	"./addMorePlusArrow.svg": "c9d1",
	"./addMoreProduct.svg": "e496",
	"./addNewBrand.svg": "4643",
	"./bars-solid.svg": "1aaf",
	"./blackTrash.svg": "5b16",
	"./check.svg": "4817",
	"./checkIcon.svg": "a341",
	"./crossIcon.svg": "5a13",
	"./deleteBtn.svg": "7b88",
	"./deleteBtnSvg.svg": "39ff",
	"./demoGoorejImg.svg": "c5c6",
	"./downArrowLQS.svg": "ca19",
	"./downPriceArrow.svg": "d276",
	"./editBtn.svg": "54b1",
	"./infoIcon.svg": "db34",
	"./lockPermission.svg": "01d9",
	"./logoutIcon.svg": "7db2",
	"./noProductImage.svg": "1368",
	"./noProductImageForComparison.svg": "5129",
	"./profile-svg.svg": "3d5e",
	"./profileIcon.svg": "23ba",
	"./redTrash.svg": "8d47",
	"./removedynamicCard.svg": "8813",
	"./settings.svg": "00c3",
	"./swapArrows.svg": "5780",
	"./trash.svg": "5c73",
	"./upArrowLQS.svg": "76c4",
	"./upPriceArrow.svg": "4f1a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "02bd";